export const ADD_CONTACT = 'Add Contact'
export const ADD_ACCOUNT = 'Add Account'
export const ADD_OPPORTUNITY = 'Add Opportunity'
export const ADD_EMPLOYEE = 'Add Employee'
export const ADD_PS = 'Add Product / Service'
export const SAVE_AND_ADD = 'Save and Add Another'
export const SAVE_AND_CLOSE = 'Save and Close'
